module.exports = __webpack_public_path__ + "static/media/powerteam.f69dd882.png";